import type { AccountCustomPortfolioQuery } from './accountCustomPortfolio.generated';
import type { CustomPortfolio, SecurityGroupAllocation } from '../types';

type Account = AccountCustomPortfolioQuery['envelopeAccount'];
type ManagedAccount = Extract<Account, { __typename: 'ManagedAccount' }>;

const toSecurityGroupAllocation = (position: ManagedAccount['securityGroupPositions'][0]): SecurityGroupAllocation => {
  const security = position.securityPositions[0].financialSecurity;
  const { id, symbol, name } = security;
  const logo = security.__typename === 'FinancialSecurityStock' ? security.companyProfile.logo : null;

  return {
    securityGroup: {
      primarySecurity: { id, symbol, name, logo },
    },
    targetWeight: position.securityGroup.targetWeight,
  };
};

export const toCustomPortfolio = (account: Account): CustomPortfolio | null => {
  if (account.__typename !== 'ManagedAccount') return null;
  if (account.portfolio.__typename !== 'RiskLevelBasedPortfolio') return null;

  return {
    id: account.portfolio.id,
    name: account.portfolio.strategy.name,
    securityGroupAllocations: account.securityGroupPositions.map(toSecurityGroupAllocation),
  };
};
